import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';
import { resolveEntityValue } from '../lib/financial-advisors/resolve-entity-value';
import type { DriverMappingConfig } from '../lib/financial-advisors/types';

export interface CardDriversProps {
  marketplaceEntity: Record<string, unknown>;
  drivers: DriverMappingConfig[];
  includeSeparator?: boolean;
}

export function CardDrivers({ marketplaceEntity, drivers, includeSeparator }: CardDriversProps) {
  const resolvedDrivers = drivers.flatMap(driver => {
    const value = resolveEntityValue(marketplaceEntity, driver.marketplaceEntityKey);
    if (!value) return [];

    return [
      {
        ...driver,
        description: resolveEntityValue(marketplaceEntity, driver.marketplaceEntityDescriptionKey),
        value,
      },
    ];
  });

  return (
    <div className="min-w-[200px]">
      {resolvedDrivers.map((driver, index) => (
        <div
          className={`flex flex-col gap-1 py-3 first:pt-0 sm:flex-row sm:gap-4 ${
            includeSeparator && index < resolvedDrivers.length - 1
              ? 'border-b border-border pb-4'
              : ''
          }`}
          key={driver.label}
        >
          <div className="typography-text-small shrink-0 text-muted-foreground sm:w-[100px] sm:pt-[3px]">
            {driver.label}&nbsp;
            {driver.tooltip ? (
              <DisclosureTooltip
                className="max-w-[340px]"
                placement="top"
                trigger={
                  <button
                    aria-label={`${driver.label} info`}
                    className="inline bg-transparent p-0 align-middle text-foreground"
                    type="button"
                  >
                    <CircleHelp aria-hidden size="0.813rem" />
                  </button>
                }
              >
                <span className="typography-text-small">{driver.tooltip}</span>
              </DisclosureTooltip>
            ) : null}
          </div>
          <div className="flex flex-col gap-1">
            <span className="typography-text-bold">{driver.value}</span>
            {driver.description ? (
              <span className="typography-text-small text-muted-foreground">
                {driver.description}
              </span>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
